module.exports = __webpack_public_path__ + "img/banner2.ba466ea3.jpg";